export default "__VITE_ASSET__tMaRxnWL__"